/* import __COLOCATED_TEMPLATE__ from './update-attribute-operation.hbs'; */
/* RESPONSIBLE TEAM: team-workflows */

import Component from '@glimmer/component';
import { action } from '@ember/object';
import { type AttributeInfoResolver } from '@intercom/embercom-prosemirror-composer';
import { tracked } from '@glimmer/tracking';
import { type OutputParam } from 'embercom/components/workflows/graph-editor/node-items/steps/fin-custom';
import type AttributeDescriptor from 'embercom/models/operator/visual-builder/attribute-descriptor';
import { EMBERCOM_PROSEMIRROR_COMPOSER_ALLOW_MOUSEDOWN_CLASS } from '@intercom/embercom-prosemirror-composer/components/editor-api/constants';
import { inject as service } from '@ember/service';

interface Args {
  resolver: AttributeInfoResolver;
  onUpdateNode: (state: Record<string, unknown>) => void;
  onCreateAttribute: (attribute: OutputParam) => AttributeDescriptor;
  closePopover: () => void;
}

export default class UpdateAttributeOperation extends Component<Args> {
  @tracked showAttributeCreationModal = false;
  @tracked showAttributeTypePickerModal = false;
  @tracked selectedAttributeType?: string;

  @service declare modalService: any;
  @service declare appService: any;

  readonly classNameToPreventComposerStealingFocus =
    EMBERCOM_PROSEMIRROR_COMPOSER_ALLOW_MOUSEDOWN_CLASS;

  get app() {
    return this.appService.app;
  }

  @action
  openModal(): void {
    if (this.app.canUseAgenticWorkflows) {
      this.showAttributeTypePickerModal = true;
    } else {
      // Open the temporary attribute creation modal when the app does not support agentic workflows
      this.showAttributeCreationModal = true;
      this.selectedAttributeType = 'temporary';
    }
  }

  @action
  onUpdateAttributeIdentifier(identifier: string): void {
    this.args.onUpdateNode({
      subjectIdentifier: identifier,
      attributeValueType: 'fin',
    });

    this.args.closePopover();
  }

  @action
  handleOnSubmit(attribute: OutputParam): void {
    let attr = this.args.onCreateAttribute(attribute);

    this.onUpdateAttributeIdentifier(attr.identifier);
  }

  @action
  openAttributeModal(type: string): void {
    this.showAttributeCreationModal = true;
    this.selectedAttributeType = type;
    this.showAttributeTypePickerModal = false;
  }

  @action
  openAttributeDetailsModal(type: string): void {
    this.modalService.openModal('settings/modals/attribute-details', {
      allowArchival: false,
      typeToCreate: type,
      showPeopleAndCompanyToggleTab: false,
      onSave: this.attributeCreated,
      useOverComposer: true,
    });
  }

  @action
  attributeCreated(attribute: $TSFixMe): void {
    this.onUpdateAttributeIdentifier(attribute.identifier);
  }
}

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'Workflows::GraphEditor::NodeItems::Steps::FinCustom::AiPromptDataPopover::UpdateAttributeOperation': typeof UpdateAttributeOperation;
  }
}
